import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import get from 'lodash/get';
import Auth from '@Services/Auth';
import Accordion from '@Pages/ProfileSettings/Preferences/components/Accordion';
import * as BrowserHelper from '@Services/BrowserHelper';
import { ProfileSettingsConfig } from '@Constants/rx-user/constants';
import { SingleSelect } from '@els/els-react--select';
import ProfileSettingsAccordionItem from '@Pages/ProfileSettings/Components/ProfileSettingsAccordionItem';

import './ResultsPerPage.scss';

const RESULTS_PER_PAGE_ROW_DATA_E2E = 'profile-settings-accordion-row-number-of-results-per-page';

function ResultsPerPage({ value, options, onChange, onSave, onClose }) {
  const isResultsPerPageLimited = get(Auth.getUser(), 'devOptions.resultsPerPageIELimit', true);
  const isIE = isResultsPerPageLimited && BrowserHelper.detectOldIE();

  if (isIE) {
    return (
      <Accordion
        open={false}
        dataE2E={RESULTS_PER_PAGE_ROW_DATA_E2E}
        className="results-per-page-accordion-item"
        heading={
          <div className="rx-accordion-row profile-settings-accordion-row disabled">
            <span className="profile-settings-accordion-row_label">{ProfileSettingsConfig.Labels.numberOfResultsPerPage}</span>
            <span className="profile-settings-accordion-row_value">{value}</span>
          </div>
        }
      />
    );
  }

  const optionsArray = options?.RX2_PAGE_SIZE?.values || [];
  const stringValue = value?.toString();

  const foundOption = optionsArray.find((option) => option.value?.toString() === stringValue);
  const defaultOption = optionsArray.find((option) => option.defaultValue === true);

  const selectedOption = foundOption || (!value && defaultOption);
  const selectedValue = selectedOption ? [selectedOption.value] : [];

  return (
    <ProfileSettingsAccordionItem
      onClose={onClose}
      onSave={onSave}
      label={ProfileSettingsConfig.Labels.numberOfResultsPerPage}
      dataE2E={RESULTS_PER_PAGE_ROW_DATA_E2E}
      title={ProfileSettingsConfig.Labels.resultsPerPage}
      value={value}
      titled
      validateOnSave
      className="results-per-page-accordion-item">
      <div className="results-per-page-accordion-item__option">
        <p>{ProfileSettingsConfig.Labels.resultsPerPage}</p>
        <SingleSelect
          label={ProfileSettingsConfig.Labels.numberOfResultsPerPage}
          shouldHideLabel
          title={ProfileSettingsConfig.Labels.resultsPerPage}
          options={optionsArray}
          isLabelInline
          size="small"
          data-e2e="results-per-page-select"
          optionsFlyoutProps={{ noInternalPadding: true, theme: 'default', placement: 'bottom', pointer: true, pointerType: 'primary' }}
          selectedOptions={selectedValue}
          onSelect={({ value: newValue }) => onChange('RX2_PAGE_SIZE', newValue)}
          required
          hideRequired
        />
      </div>
    </ProfileSettingsAccordionItem>
  );
}

ResultsPerPage.propTypes = {
  value: PropTypes.any,
  options: PropTypes.object,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
};

ResultsPerPage.defaultProps = {
  onChange: noop,
  onSave: noop,
  onClose: noop,
};

export default ResultsPerPage;
